/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-text-stroke-color',
  templateUrl: './theme-option-datalabels-text-stroke-color.component.html',
  styleUrls: ['./theme-option-datalabels-text-stroke-color.component.css']
})
export class ThemeOptionDatalabelsTextStrokeColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  textStrokeColor: string;
  optionType: ThemeOptionType = 'datalabels_textStrokeColor';

  constructor() {
    this.showDetails = false;
  }

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.textStrokeColor = this.themeOptions.datalabels(this.datalabelsIndex).textStrokeColor.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.datalabels(this.datalabelsIndex).textStrokeColor.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.textStrokeColor = value;
    this.themeOptions.setDatalabels(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.datalabelsIndex);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setDatalabels(this.optionType, this.textStrokeColor + Math.round(value * 255 / 100).toString(16), this.datalabelsIndex);
    }
    else {
      this.themeOptions.setDatalabels(this.optionType, this.textStrokeColor + '00', this.datalabelsIndex);
    }
  }

}
